import {useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {PageHeader, Tab, Tabs} from 'components';
import {TRANSLATION_KEYS} from 'locale';
import {userAuthUtils} from 'utils';

import {AssignmentWorkingHours} from './AssignmentWorkingHours';
import {PersonalWorkingHours} from './PersonalWorkingHours';
import {UserWorkingHours} from './UserWorkingHours';
import {WorkingHoursTimeline} from './WorkingHoursTimeline';

const T_KEYS = TRANSLATION_KEYS.USER.ACCOUNT.WORKING_HOURS;

export const WorkingHours: React.FC = () => {
    const {t} = useTranslation();

    const {personal, assignment, users, timeline} = useMemo(() =>
        userAuthUtils.getUserPermissions()?.account?.workingHours || {personal: null, assignment: null, users: null, timeline: null}, []);

    return (
        <div>
            <PageHeader title={t(T_KEYS.TITLE)} description={t(T_KEYS.DESCRIPTION)} />
            <Tabs className='scrollbar-hide' overflow={false}>
                <Tab name={t(T_KEYS.SECTIONS.PERSONAL)} hidden={!personal}>
                    <PersonalWorkingHours />
                </Tab>
                <Tab name={t(T_KEYS.SECTIONS.ASSIGNMENT)} hidden={!assignment}>
                    <AssignmentWorkingHours />
                </Tab>
                <Tab name={t(T_KEYS.SECTIONS.USER)} hidden={!users}>
                    <UserWorkingHours />
                </Tab>
                <Tab name={t(T_KEYS.SECTIONS.TIMELINE)} hidden={!timeline}>
                    <WorkingHoursTimeline />
                </Tab>
            </Tabs>
        </div>
    );
};